import { Injectable } from '@angular/core';

import { PessoaDomain } from '@/core/api/sicom-api/registro/pessoa/pessoa.domain';
import { PrestadorCorpoSocietarioSocioResponse } from '@/core/api/sicom-api/registro/prestador/prestador-corpo-societario.model';
import { PrestadorFinanceiroNavigationService } from '@/features/registro/prestadores/dashboard-prestadores/components/prestador-financeiro-navigation.service';

export const CORPO_SOCIETARIO_FINANCEIRO_RETURN_CONTEXT_ID = 'corpo-societario-financeiro';

@Injectable({ providedIn: 'root' })
export class CorpoSocietarioFinanceiroNavigationService {
    constructor(private readonly financeiroNavigationService: PrestadorFinanceiroNavigationService) {}

    abrirSocio(prestadorAtual: PessoaDomain | undefined, socio: PrestadorCorpoSocietarioSocioResponse): void {
        if (!prestadorAtual?.id || !prestadorAtual.uf || !socio.idSocio || !socio.ufSocio) {
            return;
        }

        this.financeiroNavigationService.abrirMedico(
            prestadorAtual,
            {
                id: socio.idSocio,
                uf: socio.ufSocio,
                crm: socio.crm ?? undefined,
                nome: socio.nome ?? undefined,
                tipo: this.tipoPessoa(socio)
            },
            { id: CORPO_SOCIETARIO_FINANCEIRO_RETURN_CONTEXT_ID, returnUrl: '/prestadores/corpo-societario' }
        );
    }

    private tipoPessoa(socio: PrestadorCorpoSocietarioSocioResponse): string | undefined {
        if (socio.tipoCodigo === 1) return 'MEDICO';
        if (socio.tipoCodigo === 5) return 'PRESTADOR';
        if (socio.tipoCodigo === 4) return 'OUTROSPJ';
        if (socio.tipoCodigo === 6) return 'OUTROSPF';
        return socio.tipo ?? undefined;
    }
}
